import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import { UserContext } from "../component/layout/layout";
import PageNotFound from "../common/PageNotFound";
function NotFoundRoute() {
  return <h3> 404 Page not Found</h3>;
}

const ProtectedRoutes = (props: any) => {
  const location: any = useLocation();
  const { user, setUser }: any = useContext(UserContext);
  const [paths, setPaths] = useState<Array<string>>([]);
  const [currentPath, setCurrentPath] = useState<string>("");
  const [loading, setLoading] = useState(false);

  const { Component } = props;
  const navigate = useNavigate();
  let token = localStorage.getItem("accessToken");
  useEffect(() => {
    token = localStorage.getItem("accessToken");
    setLoading(true);
    if (!token) {
      navigate("/login");
    }
    const Paths = user?.access?.map((name: string) => {
      return name?.replace(/\s/g, "").toLowerCase();
    });
    setPaths(Paths);

    setCurrentPath(location.pathname?.split("/").join("").toLowerCase());
    setLoading(false);
  }, [token]);
  
  return (
    <>
      {loading ? (
        <h3> Loading</h3>
      ) : paths?.some(
          (item: string) =>
            item?.toLowerCase() ===
              location.pathname
                ?.split("/")
                .join("")
                .replace(/\d+/g, "")
                ?.toLowerCase() ||
            user.RoleAccess[
              location.pathname?.split("/")[1]?.toLowerCase()
            ]?.some(
              (item: string) =>
                location.pathname
                  ?.split("/")[2]
                  ?.toLowerCase()
                  ?.includes(item?.toLowerCase()) ||
                item?.toLowerCase() === "all"
            )
        ) && token ? (
        <Component />
      ) : (
      null
      )}
    </>
  );
};

export default ProtectedRoutes;
